var Industry = "產業";
var Aerospace = "航太";
var Agriculture = "農業";
var Automotive = "汽車";
var Education = "教育";
var Gaming = "遊戲";
var Government = "政府";
var Healthcare = "醫療保健";
var Hospitality = "餐旅業";
var Manufacturing = "製造業";
var Mining = "礦業";
var Other = "其他";
var Retail = "零售業";
var Telecommunications = "電信";
var Travel = "旅遊";
var industry = {
	Industry: Industry,
	Aerospace: Aerospace,
	Agriculture: Agriculture,
	Automotive: Automotive,
	"Computers & electronics": "電腦與電子業",
	"Consumer goods": "消費產品",
	Education: Education,
	"Financial services": "金融服務",
	Gaming: Gaming,
	Government: Government,
	Healthcare: Healthcare,
	Hospitality: Hospitality,
	"Life sciences": "生命科學",
	Manufacturing: Manufacturing,
	"Marketing & advertising": "行銷和廣告",
	"Media & entertainment": "媒體與娛樂",
	Mining: Mining,
	"Non-profit organization": "非營利組織",
	"Oil & gas": "石油和天然氣",
	Other: Other,
	"Power & utilities": "電力與公用事業",
	"Professional services": "專業服務",
	"Real estate & construction": "房地產與營造業",
	Retail: Retail,
	"Software & internet": "軟體與網際網路",
	Telecommunications: Telecommunications,
	"Transportation & logistics": "運輸與物流業",
	Travel: Travel,
	"Wholesale & distribution": "批發與流通業"
};

export { Aerospace, Agriculture, Automotive, Education, Gaming, Government, Healthcare, Hospitality, Industry, Manufacturing, Mining, Other, Retail, Telecommunications, Travel, industry as default };
